import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Workspaces/Settings/Calendar'
import {
  workspaceSettingsLayoutRoute,
  workspaceSettingsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Settings/Routing'

export const calendarRoute = createRoute({
  getParentRoute: () => workspaceSettingsRoute,
  path: StaticRouteParameter.CALENDAR,
  loader: () => ({
    crumb: t('pages:Workspace.calendar'),
  }),
})

export const calendarOverviewRoute = createRoute({
  getParentRoute: () => workspaceSettingsLayoutRoute,
  path: `${StaticRouteParameter.CALENDAR}/`,
  component: Overview,
})
